import React from "react";
import { Check } from "@phosphor-icons/react";

const Choice = ({ selected, onClick, children, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    aria-pressed={selected}
    className={`w-full text-left px-5 py-4 border flex items-center justify-between gap-4 transition-colors duration-200 ${
      selected ? "border-exodus-gold bg-exodus-gold/10 text-exodus-text" : "border-exodus-border bg-exodus-surface text-exodus-text/90 hover:border-exodus-gold/60"
    }`}
  >
    <span className="text-sm sm:text-base">{children}</span>
    <span className={`w-5 h-5 shrink-0 border flex items-center justify-center ${selected ? "bg-exodus-gold border-exodus-gold text-black" : "border-exodus-border"}`}>
      {selected && <Check size={12} weight="bold" />}
    </span>
  </button>
);

function BucketMix({ q, value = {}, onChange }) {
  return (
    <div className="space-y-6">
      {q.buckets.map((b) => (
        <div key={b.key} data-testid={`bucket-row-${b.key}`}>
          <p className="eyebrow mb-3">{b.label}</p>
          <div className="flex flex-wrap gap-2">
            {q.options.map((op) => {
              const sel = value[b.key] === op.value;
              return (
                <button
                  key={op.value}
                  type="button"
                  data-testid={`bucket-${b.key}-${op.value}`}
                  onClick={() => onChange({ ...value, [b.key]: op.value })}
                  className={`px-3 py-2 text-xs sm:text-sm border transition-colors duration-200 ${
                    sel ? "border-exodus-gold bg-exodus-gold text-black" : "border-exodus-border text-exodus-text/80 hover:border-exodus-gold/60"
                  }`}
                >
                  {op.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function ClarityQuestion({ q, value, onChange, answers }) {
  if (q.type === "bucket_mix") return <BucketMix q={q} value={value} onChange={onChange} />;
  if (q.type === "multi") {
    const arr = value || [];
    return (
      <div className="grid sm:grid-cols-2 gap-3">
        {q.options.map((op) => (
          <Choice key={op.value} testid={`opt-${q.id}-${op.value}`} selected={arr.includes(op.value)}
            onClick={() => onChange(arr.includes(op.value) ? arr.filter((v) => v !== op.value) : [...arr, op.value])}>
            {op.label}
          </Choice>
        ))}
      </div>
    );
  }
  const opts = q.type === "top_pick" ? q.options.filter((op) => (answers[q.source] || []).includes(op.value)) : q.options;
  return (
    <div className="space-y-3">
      {opts.map((op) => (
        <Choice key={op.value} testid={`opt-${q.id}-${op.value}`} selected={value === op.value} onClick={() => onChange(op.value)}>
          {op.label}
        </Choice>
      ))}
    </div>
  );
}
